{
 "_note": "English text for batches/jobs (v1.3.23). Chinese stays in the data base fields; *_en here is used only when the data has no *_en of its own. Titles/hypotheses/findings from VGB; condition names from prod v1.3.2 (WB->white balance, color NL->color in plain words).",
 "batches": {
  "v_formal": {
   "title_en": "V group",
   "hypothesis_en": "Previz drives the dolly-in.",
   "jobs": {
    "P00V_o3": {
     "cond_label_en": "white-model skin swap, dolly"
    }
   }
  },
  "formal": {
   "title_en": "Formal comparison",
   "hypothesis_en": "Change focal length, camera height, aperture, color, white balance, camera move, lighting and pacing, two runs each, plus one unchanged control.",
   "jobs": {
    "kling_A0_1": {
     "cond_label_en": "control"
    },
    "kling_A0_2": {
     "cond_label_en": "control"
    },
    "kling_A1_1": {
     "cond_label_en": "focal"
    },
    "kling_A1_2": {
     "cond_label_en": "focal"
    },
    "kling_A2_1": {
     "cond_label_en": "focal"
    },
    "kling_A2_2": {
     "cond_label_en": "focal"
    },
    "kling_A3_1": {
     "cond_label_en": "camera height"
    },
    "kling_A3_2": {
     "cond_label_en": "camera height"
    },
    "kling_A4_1": {
     "cond_label_en": "camera height"
    },
    "kling_A4_2": {
     "cond_label_en": "camera height"
    },
    "kling_B1_1": {
     "cond_label_en": "aperture"
    },
    "kling_B1_2": {
     "cond_label_en": "aperture"
    },
    "kling_B2_1": {
     "cond_label_en": "aperture"
    },
    "kling_B2_2": {
     "cond_label_en": "aperture"
    },
    "kling_C3a_1": {
     "cond_label_en": "LUT text only"
    },
    "kling_C3a_2": {
     "cond_label_en": "LUT text only"
    },
    "kling_C3b_1": {
     "cond_label_en": "colorspace text"
    },
    "kling_C3b_2": {
     "cond_label_en": "colorspace text"
    },
    "kling_D1_1": {
     "cond_label_en": "color hex"
    },
    "kling_D1_2": {
     "cond_label_en": "color hex"
    },
    "kling_D2_1": {
     "cond_label_en": "color in plain words"
    },
    "kling_D2_2": {
     "cond_label_en": "color in plain words"
    },
    "kling_E1_1": {
     "cond_label_en": "white balance"
    },
    "kling_E1_2": {
     "cond_label_en": "white balance"
    },
    "kling_E2_1": {
     "cond_label_en": "white balance"
    },
    "kling_E2_2": {
     "cond_label_en": "white balance"
    },
    "kling_G1_1": {
     "cond_label_en": "motion"
    },
    "kling_G1_2": {
     "cond_label_en": "motion"
    },
    "kling_G2_1": {
     "cond_label_en": "motion"
    },
    "kling_G2_2": {
     "cond_label_en": "motion"
    },
    "kling_G3_1": {
     "cond_label_en": "motion"
    },
    "kling_G3_2": {
     "cond_label_en": "motion"
    },
    "kling_G4_1": {
     "cond_label_en": "motion"
    },
    "kling_G4_2": {
     "cond_label_en": "motion"
    },
    "kling_G5_1": {
     "cond_label_en": "motion"
    },
    "kling_G5_2": {
     "cond_label_en": "motion"
    },
    "kling_G6_1": {
     "cond_label_en": "motion"
    },
    "kling_G6_2": {
     "cond_label_en": "motion"
    },
    "kling_G7_1": {
     "cond_label_en": "motion"
    },
    "kling_G7_2": {
     "cond_label_en": "motion"
    },
    "kling_G8_1": {
     "cond_label_en": "multi_shot 5s+5s"
    },
    "kling_G8_2": {
     "cond_label_en": "multi_shot 5s+5s"
    },
    "kling_M1_1": {
     "cond_label_en": "lighting"
    },
    "kling_M1_2": {
     "cond_label_en": "lighting"
    },
    "kling_M2_1": {
     "cond_label_en": "lighting"
    },
    "kling_M2_2": {
     "cond_label_en": "lighting"
    },
    "kling_M3_1": {
     "cond_label_en": "pace"
    },
    "kling_M3_2": {
     "cond_label_en": "pace"
    },
    "kling_M4_1": {
     "cond_label_en": "pace"
    },
    "kling_M4_2": {
     "cond_label_en": "pace"
    }
   }
  },
  "route_ablation_g127": {
   "title_en": "Camera route",
   "hypothesis_en": "Static, dolly-in and orbit, each with one run without previz and one with.",
   "findings_en": [
    {
     "label": "Static",
     "text": "Prompt-only drifts into a slow turn; with previz it truly holds still."
    },
    {
     "label": "Dolly-in",
     "text": "Both push in; the previz run is more accurate."
    },
    {
     "label": "Orbit",
     "text": "The first pass turned into a roll; after the rerun we stop here, no more reruns."
    }
   ],
   "jobs": {
    "G1_i2v": {
     "cond_label_en": "static"
    },
    "G1_omni": {
     "cond_label_en": "static"
    },
    "G2_i2v": {
     "cond_label_en": "dolly_in"
    },
    "G2_omni": {
     "cond_label_en": "dolly_in"
    },
    "G7_i2v": {
     "cond_label_en": "orbit_360_yaw"
    },
    "G7_omni": {
     "cond_label_en": "orbit_360_yaw"
    },
    "route_G7_i2v_r2": {
     "cond_label_en": "orbit_360_yaw"
    },
    "route_G7_omni_r2": {
     "cond_label_en": "orbit_360_yaw"
    }
   }
  }
 }
}